import { action, observable, runInAction, computed } from 'mobx'
import Api from '@api/xi_feng/newCustomer'
import { message, Modal } from 'hljd'
import isEmpty from 'lodash/isEmpty'
import FollowModalStore from './left/FollowModal/store'
import CollaborateModalStore from './left/CollaborateModal/store'
import {
  PROPERTY_WITH_WEDDING_OBJ,
  TAB_UPDATE_RECORD,
  FOLLOW_STATUS_NOT,
  TAB_TASK,
  TASK_STATUS_TODO
} from '../constant'
import moment from 'moment'
import { dGet } from '@core/utils'
import { REACT_ANTD_PATH } from '@constant'
import JiaMengApi from '@api/jiaMeng'
import ExperienceApi from '@api/experienceShop'
import { omit } from '@hlj/hlj-utils'
import React from 'react'

class Store {
  id
  @observable searchResult = []
  @observable propertyList = []
  @observable type = TAB_UPDATE_RECORD // tab 类型，更新记录，联系，签单，任务
  @observable customerVisible = false
  @observable detailData = {}
  @observable staffList = []
  @observable cardList = []
  @observable supportList = []
  @observable budgetList = []
  @observable contactModalVisible = false // 沟通记录 modal
  @observable contactType = '' // 沟通记录类型
  @observable signModalVisible = false // 签单 modal
  @observable taskModalVisible = false // 任务 modal
  @observable confirmTaskModalVisible = false // 任务确认完成 modal
  @observable insertCoopOrderModalVisible = false // 录入合作订单 modal
  @observable paymentModalVisible = false // 确定扣款 modal
  @observable applyDeductFeeModalVisible = false // 申请扣除服务费 modal
  @observable applyReturnFeeModalVisible = false // 申请退还服务费 modal
  @observable currentCooperateOrder = {} // 当前操作的体验店合作订单
  @observable currentBrokerageOrder = {} // 当前操作的体验店合作订单下的某笔服务订单
  @observable currentTask = {} // 当前任务
  @observable loadingCards = false
  @observable currentCard = {} // 当前编辑的 card
  @observable surveyInfo = [] // 调查问卷信息
  @observable orderMerchantList = [] // 体验店已派商家列表

  callbackAfterGetCustomerList = null

  constructor() {
    this.followModalStore = new FollowModalStore(this)
    this.collaborateModalStore = new CollaborateModalStore(this)
  }

  setStoreData = (data = []) => {
    data.forEach(item => {
      this[item.type] = item.value
    })
  }

  refresh = () => {
    this.getCardList()
    this.getCustomerDetail()
  }

  @action
  getCustomerDetail = async () => {
    const { data, success } = await Api.getCustomerDetail({ id: this.id })
    if (!success) {
      return
    }
    let city_id = []
    let city_name = []
    if (data.full_address_info) {
      if (data.full_address_info.province) {
        city_id.push(data.full_address_info.province.id)
        city_name.push(data.full_address_info.province.name)
      }
      if (data.full_address_info.city) {
        city_id.push(data.full_address_info.city.id)
        city_name.push(data.full_address_info.city.name)
      }
      if (data.full_address_info.district) {
        city_id.push(data.full_address_info.district.id)
        city_name.push(data.full_address_info.district.name)
      }
    }
    data.city_id = city_id
    data.city_name = city_name
    // 执行一次立即清空
    if (this.callbackAfterGetCustomerList) {
      setTimeout(() => {
        this.callbackAfterGetCustomerList && this.callbackAfterGetCustomerList()
        this.callbackAfterGetCustomerList = null
      }, 1000)
    }

    runInAction(() => {
      this.detailData = data
      this.budgetList = data.demand_list
    })
  }

  @action
  finish = async remark => {
    const { success } = await Api.finish({ remark, id: this.id })
    if (success) {
      message.success('已完成')
      this.refresh()
    }
  }

  timer
  @action
  onSearch = title => {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
    const fake = async () => {
      const { data } = await Api.getSearchList({ title })
      this.searchResult = !isEmpty(data) ? data : []
    }
    this.timer = setTimeout(fake, 300)
  }

  @action
  getStaffList = async () => {
    const { data } = await Api.getStaffList()
    this.staffList = data
  }

  @action
  changeMerchant = async (body, channel_id, chatBody) => {
    const { success } = await Api.changeMerchant({ ...body, id: this.id })
    if (!success) {
      return
    }
    if (channel_id && channel_id > 0) {
      const { RetCode: code, msg: msg1 } = await Api.changeChat(
        channel_id,
        chatBody
      )
      if (code != 0) {
        return message.error(msg1)
      }
    }
    message.success('移交成功')
    this.refresh()
  }

  @action
  onBudgetItemChange = value => {
    const budgetList = value.map(item => {
      const idx = this.budgetList.findIndex(budget => {
        return budget.property_id == item
      })
      if (idx < 0) {
        return {
          property_name: PROPERTY_WITH_WEDDING_OBJ[item],
          budget_money: 0,
          remark: '',
          property_id: item
        }
      } else {
        return this.budgetList[idx]
      }
    })
    this.budgetList = budgetList
  }

  @action
  delBudgetItem = index => {
    let budgetList = this.budgetList.filter((item, idx) => idx !== index)
    this.budgetList = budgetList
  }

  @action
  getBudget = async value => {
    const { data, success } = await Api.getBudget(value)
    if (success) {
      this.budgetList = data
    }
  }

  @action
  modifyCustomer = async (body, not_close_modal) => {
    const { success } = await Api.modifyCustomer({ ...body, id: this.id })
    if (success) {
      message.success('编辑成功')
      this.refresh()
      if (!not_close_modal) {
        this.customerVisible = false
      }
    }
  }

  // 新的跟进/确认签单
  @action
  createFollowUp = async value => {
    const { success } = await Api.createFollowUp({ ...value, id: this.id })
    if (success) {
      this.refresh()
    }
  }

  /**
   * 创建任务
   */
  createTask = async value => {
    const { success } = await Api.createTask({ ...value, id: this.id })
    if (success) {
      this.setStoreData([{ type: 'taskModalVisible', value: false }])
      this.refresh()
    }
  }

  /**
   * 创建沟通记录
   */
  createContact = async value => {
    const { success } = await Api.createContact({ ...value, id: this.id })
    if (success) {
      this.setStoreData([{ type: 'contactModalVisible', value: false }])
      this.refresh()
    }
  }

  /**
   * 创建签单
   */
  createSign = async value => {
    const { success } = await Api.createSign({ ...value, id: this.id })
    if (success) {
      this.setStoreData([{ type: 'signModalVisible', value: false }])
      this.refresh()
    }
  }

  /**
   * 体验店派单
   */
  customerToLeads = async () => {
    const { user_phone, merchant_support } = this.detailData
    if (!user_phone) {
      return message.warn('该客户没有手机号码，无法派单')
    }

    const { success } = await Api.customerToLeads({
      merchant_customer_id: this.detailData.id,
      merchant_support_id:
        merchant_support && merchant_support[0] && merchant_support[0]['id']
    })

    if (success) {
      window.open(REACT_ANTD_PATH)
    }
  }

  /**
   * 确认完成任务
   */
  submitFinishTask = async params => {
    const { success } = await JiaMengApi.submitFinishTask({
      task_id: this.currentTask.id,
      ...params
    })

    if (success) {
      this.setStoreData([
        { type: 'confirmTaskModalVisible', value: false },
        { type: 'currentTask', value: {} }
      ])
      this.refresh()
    }
  }

  /**
   * 商家补单
   */
  createOrder = async params => {
    const { success } = await Api.createOrder({
      merchant_customer_id: this.detailData.id,
      ...params
    })

    if (success) {
      this.closePaymentModal()
      this.refresh()
    }
  }

  closePaymentModal = () => {
    this.setStoreData([
      { type: 'paymentModalVisible', value: false },
      { type: 'orderMerchantList', value: [] }
    ])
  }

  getPropertyList = async () => {
    const { success, data } = await Api.getPropertyList()
    if (success) {
      this.propertyList = data || []
    }
  }

  getOrderMerchantList = async property_id => {
    const { success, data } = await Api.orderMerchant({
      merchant_customer_id: this.detailData.id,
      property_id
    })
    if (success) {
      this.orderMerchantList = data || []
    }
  }

  getCardList = async () => {
    this.loadingCards = true
    const { data, success } = await Api.getCardList({
      id: this.id,
      page: 1,
      per_page: 1000,
      type: this.type
    })
    this.loadingCards = false
    if (success) {
      this.cardList = data.list
    }
  }

  @action
  getSupportList = async id => {
    const { data, success } = await Api.getSupportList({
      id
    })
    if (success) {
      this.supportList = data
    }
  }

  /**
   * 打开/关闭联系弹窗
   * 联系和到店共用
   */
  openOrCloseContactModal = (show, contactType = '') => {
    this.setStoreData([
      { type: 'contactModalVisible', value: show },
      { type: 'contactType', value: contactType }
    ])
  }

  getCurrentTask = async id => {
    const { data } = await JiaMengApi.getTaskDetail({ id })
    this.currentTask = data || {}
  }

  @computed
  get isNotFollow() {
    return this.detailData.follow_status == FOLLOW_STATUS_NOT
  }

  @computed
  get customerName() {
    const { user_name, nick } = this.detailData
    return user_name || nick || dGet(this.detailData, 'user.nick')
  }

  /**
   * 归属人名字
   */
  @computed
  get supportNames() {
    return (this.detailData.merchant_support || [])
      .map(item => {
        return item.nick
      })
      .join('、')
  }

  @computed
  get formattedCardList() {
    const key = 'latest'
    // 任务 card 需区分即将发生
    if (this.type === TAB_TASK || this.type === TAB_UPDATE_RECORD) {
      let list = this.cardList.reduce((acc, item) => {
        if (item.card_type === 'task_card') {
          const { status } = dGet(item, 'task_card', {})
          if (status == TASK_STATUS_TODO) {
            return this.setItemToAcc(acc, item, key)
          } else {
            return this.setItemToAcc(acc, item)
          }
        } else {
          return this.setItemToAcc(acc, item)
        }
      }, {})

      /**
       * 将即将到来的任务放在最上面
       */
      let latestFirstDateList = {}
      if (list.hasOwnProperty(key)) {
        latestFirstDateList[key] = list[key]
        list = omit(list, [key])
      }

      latestFirstDateList = { ...latestFirstDateList, ...list }

      return latestFirstDateList
    }

    return this.cardList.reduce((acc, item) => {
      return this.setItemToAcc(acc, item)
    }, {})
  }

  setItemToAcc = (acc, item, key) => {
    const date = moment(item.order_at)
    key = key || date.format('YYYY-MM-DD')

    if (acc.hasOwnProperty(key)) {
      acc[key].push(item)
    } else {
      acc[key] = [item]
    }
    return acc
  }

  /**
   * 下面是体验店逻辑，待抽出
   */
  openApplyDeductFeeModal = (cooperate_order_id, brokerage_id) => {
    this.getCooperateOrder(cooperate_order_id)
    if (brokerage_id) {
      this.getBrokerageOrder(brokerage_id)
    }
    this.applyDeductFeeModalVisible = true
  }

  closeApplyDeductFeeModal = () => {
    this.currentCooperateOrder = {}
    this.currentBrokerageOrder = {}
    this.applyDeductFeeModalVisible = false
  }

  openApplyReturnFeeModal = brokerage_id => {
    this.getBrokerageOrder(brokerage_id)
    this.applyReturnFeeModalVisible = true
  }

  closeApplyReturnFeeModal = () => {
    this.currentBrokerageOrder = {}
    this.applyReturnFeeModalVisible = false
  }

  createCooperateOrder = async params => {
    const { success } = await ExperienceApi.createCooperateOrder({
      merchant_customer_id: this.detailData.id,
      ...params
    })
    if (success) {
      message.success('操作成功')
      this.insertCoopOrderModalVisible = false
      this.refresh()
    }
  }

  /**
   * 合作订单创建信息
   */
  getCooperateOrder = async cooperate_order_id => {
    const { data } = await ExperienceApi.getCooperateOrder({
      cooperate_order_id
    })
    this.currentCooperateOrder = data
  }

  getBrokerageOrder = async brokerage_id => {
    const { data } = await ExperienceApi.getBrokerageOrder({
      brokerage_id
    })
    this.currentBrokerageOrder = data
  }

  /**
   * 申请扣除服务费
   */
  createBrokerageOrder = async params => {
    const { id: cooperate_order_id } = this.currentCooperateOrder
    const postData = {
      cooperate_order_id,
      ...params
    }

    if (this.currentBrokerageOrder.id) {
      postData.brokerage_id = this.currentBrokerageOrder.id
    }

    const { data, success } = await ExperienceApi.createBrokerageOrder(postData)

    if (success) {
      // 服务费账户余额不足
      if (data.retCode == 1001) {
        const { merchant, property, activeBalance } = data
        Modal.info({
          title: '服务费账户余额不足，无法申请扣款',
          content: (
            <div>
              <p>商家名：{merchant.name}</p>
              <p>类目：{property.name}</p>
              <p>服务费账户可用余额(不包含审批中锁定的)：{activeBalance}</p>
              <p>本次准备扣款金额：{params.money}</p>
              <p>请联系商家充值服务费余额</p>
            </div>
          ),
          okText: '我知道了'
        })
        return
      }

      message.success('操作成功')
      this.closeApplyDeductFeeModal()
      this.refresh()
    }
  }

  applyRefund = async params => {
    const { success } = await ExperienceApi.applyRefund({
      brokerage_id: this.currentBrokerageOrder.id,
      ...params
    })
    if (success) {
      message.success('操作成功')
      this.closeApplyReturnFeeModal()
      this.refresh()
    }
  }
}

export default Store
